// ============================================================================
// auditFields.ts — СИСТЕМНЫЕ аудит-поля объектов (SSoT — сервер,
// metadata.AuditFieldDefs): Создал/Дата создания/Изменил/Дата изменения.
// Единый реестр для клиента: аудит-поля НЕ редактируются (readonly) и
// выводятся горизонтальной строкой внизу объектной формы (аудит-бар).
// ============================================================================

/** column_name системных аудит-полей (как metadata.AuditFieldDefFor). */
export const AUDIT_COLUMNS = ['created_by', 'created_at', 'updated_by', 'updated_at'] as const;

/** Аудит-ли это поле (по column_name/code/последнему сегменту пути). */
export function isAuditField(code: string): boolean {
  const key = String(code || '').split('.').pop() || '';
  return AUDIT_COLUMNS.includes(key as (typeof AUDIT_COLUMNS)[number]);
}
